import { render, staticRenderFns } from "./SelectSms.vue?vue&type=template&id=80bf8c02&scoped=true&"
import script from "./SelectSms.vue?vue&type=script&lang=js&"
export * from "./SelectSms.vue?vue&type=script&lang=js&"
import style0 from "./SelectSms.vue?vue&type=style&index=0&id=80bf8c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bf8c02",
  null
  
)

export default component.exports